import { Theme } from '@mui/material';
import createStyles from '@mui/styles/createStyles';

export default ({ palette: { colors } }: Theme) =>
  createStyles({
    popupContent: {
      position: 'absolute',
      top: '1px',
      left: '1px',
      height: '100vh',
      width: '100vw',
      background: 'rgba(31,31,31, 0.34)',
      outline: 'none',
    },
    showed: {
      display: 'block',
    },
    hidden: {
      display: 'none',
    },

    root: {
      flexGrow: 1,
    },
    paper: {
      padding: '32px 32px 24px 32px',
      margin: 'auto',
      maxWidth: '512px',
      minWidth: '512px',
    },
    buttonsSection: {
      paddingTop: 24,
    },
    cancelButton: {
      fontSize: 16,
      color: '#828F95',

      '& span': {
        fontWeight: 500,
      },
    },
    submitButton: {
      maxHeight: 40,
      minWidth: 73,
      fontSize: 16,
      backgroundColor: `${colors.primaryAccent} !important`,
      color: `${colors.white} !important`,
      boxShadow: 'none !important',
      border: 'none !important',

      '&:hover': {
        boxShadow: '0px 0px 10px rgba(160, 160, 160, 0.9) !important',
      },
    },
    deleteButton: {
      backgroundColor: '#FF4848 !important',
      color: `${colors.white} !important`,
      border: 'none !important',

      '&:hover': {
        backgroundColor: '#ff2a2a !important',
      },
    },
    childContent: {
      paddingTop: 16,
    },
    text: {
      fontSize: 16,
      lineHeight: '24px',
      color: '#828F95',
    },
  });
